export default class DebitList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch (company_id) {

		let data = await Anvil.REST.get(`/c_order/debit/list/${company_id}`)

		for (const entry of data) {
			if (entry.start_d) {
				entry.start_d = Anvil.moment(entry.start_d).format('YYYY-MM-DD')
			}
			if (entry.end_d) {
				entry.end_d = Anvil.moment(entry.end_d).format('YYYY-MM-DD')
			}
		}

		return new DebitList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
